jQuery(function() {
    
    $('#prev-box').hover(function(){
        $('#prev-box').addClass('long');
        $('#next-box').addClass('short');
        $('#txt-target').fadeOut(200);
	},function(){
		$('#prev-box').removeClass('long');
        $('#next-box').removeClass('short');
        $('#txt-target').fadeIn(200);
	});
});